import sightseaLight from './sightsea-light.svg'
import sightseaWhite from './sightsea-white.svg'
import logoApple from './logoApple.svg'
import logoGoogle from './logoGoogle.svg'
import menu from './menu.svg'
import noti from './noti.svg'
import logoETH from './logoETH.svg'
import iconHiddenEye from './iconHiddenEye.svg'
import iconClose from './iconClose.svg'
import changeCrible from './changeCrible.svg'
import unMessage from './unMessage.svg'
import btnClose from './btnClose.svg'
import btnBack from './btnBack.svg'
import dowloadAppStore from './dowloadAppStore.svg'
import dowloadGooglePlay from './dowloadGooglePlay.svg'
import logoSightSeaV3 from './logoSightSeaV3.svg'
import LogoFaceBook from './logo-facebook.svg'
import LogoTikTok from './logo-tiktok.svg'
import LogoTwitter from './logo-twitter.svg'
import share from './share.svg'
import key from './key.svg'
import iconVerifyAccount from './iconVerifyAccount.svg'
import iconKey from './iconKey.svg'
import icLogo from './icLogo.svg'
import eth from './eth.svg'
import binance from './binance.svg'
import bera from './beraChain.svg'

const SVGS = {
  sightseaLight,
  logoApple,
  logoGoogle,
  sightseaWhite,
  menu,
  noti,
  logoETH,
  iconHiddenEye,
  iconClose,
  changeCrible,
  unMessage,
  btnClose,
  btnBack,
  dowloadAppStore,
  logoSightSeaV3,
  dowloadGooglePlay,
  share,
  LogoFaceBook,
  LogoTikTok,
  LogoTwitter,
  key,
  iconVerifyAccount,
  iconKey,
  icLogo,
  eth,
  binance,
  bera,
}

export default SVGS
